/**
 * @public
 * Merges all inner arrays into one-level depth array.
 *
 * @see https://gist.github.com/jherax/7dce66c97ea06150e00c5a6febec26e7
 *
 * @param  {Array} array: the array to be flattened
 * @return {Array}
 */
export default function flatten(array) {
  return array.reduce((flat, cv) =>
    flat.concat(Array.isArray(cv) ? flatten(cv) : cv), []);
}
